<div *ngIf="existingbooking" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <span>
        <h1 class="screen-title">{{ ebScreenTitle }}</h1>
      </span>

      <span *ngIf="Errmessage != ''">
        <p class="errMsg">{{Errmessage}}</p>
      </span>
      <div class="sdiv" style="margin-top: 20px;margin-right: 10px;">
        <label class=""> Accrual</label>
        <input type="radio" value="A" name="type" checked (click)="selectTypeOfRedemption('A')">
        <label class=""> Redemption</label>
        <input type="radio" value="R" name="type"  (click)="selectTypeOfRedemption('R')">
        
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 4% 2% 2%">
                  <div>
                    <div>
                      <div class="instruct">
                        <div class="int1" style="margin-left: 17px">
                          <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                          <br>
                          <span class="txt"> 1. Select atleast one value out of INTERMILES Number,Airline PNR,Booking
                            Reference
                            No,Ticket
                            No,First Name,Last Name,Booking Status. </span>
                          <br>
                          <span class="txt"> 2. If using date range one date range is required. </span>
                          <br>
                          <span></span>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label>INTERMILES Number </label>
                        <input [(ngModel)]="ebSearch_details.jp_number" (keypress)='keypresshandler($event)'
                          maxlength="11" type="text" class="form-control m-input" placeholder="Enter INTERMILES Number"
                          (keyup)="jpNumberValidation();" (input)="isEmpty()" />
                        <span id="JpErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Airline PNR</label>
                        <input [(ngModel)]="ebSearch_details.airlinepnr" type="text" class="form-control m-input"
                          placeholder="Enter Airline PNR" style="text-transform: uppercase" maxlength="6"
                          (keyup)="pnrValidation();" (input)="isEmpty()" />
                        <span id="pnrNO"></span>
                      </div>

                      <div class="col-md-3">
                        <label class="">Booking Reference No</label>
                        <input [(ngModel)]="ebSearch_details.order_id" maxlength="18" id="bookingRef" type="text"
                          class="form-control m-input" placeholder="Enter Booking Reference No"
                          style="text-transform: uppercase" (blur)="orderValidation1()" (keyup)="orderValidation();"
                          (input)="isEmpty()" />
                        <span id="orErr"></span>
                      </div>

                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3">
                        <label class="">Ticket No </label>
                        <input [(ngModel)]="ebSearch_details.Ticket_No" type="text" class="form-control m-input"
                          placeholder="Enter Ticket No" maxlength="15" (input)="isEmpty()" />
                        <span id="orErr"></span>
                      </div>

                      <div class="col-md-3">
                        <label class="">First Name</label>

                        <input [(ngModel)]="ebSearch_details.first_name" type="text" class="form-control m-input"
                          placeholder="Enter First Name" (keyup)="fnameValidation();" (input)="isEmpty()" />
                        <span id="fnErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Last Name</label>
                        <input [(ngModel)]="ebSearch_details.last_name" type="text" class="form-control m-input"
                          placeholder="Enter Last Name" (keyup)="lnameValidation(); " (input)="isEmpty()" />
                        <span id="lnErr"></span>
                      </div>


                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3">
                        <label class="">Booking Status</label>
                        <select class="form-control m-input" (change)="isEmpty()" [(ngModel)]="ebSearch_details.status">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option *ngFor="let item of booking_status" value="{{ item.key }}">{{ item.value }}</option>
                        </select>
                      </div>
                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input id="did" #input3 matInput [(ngModel)]="ebSearch_details.bookingdate_from"
                            [matDatepicker]="pickerFrom1" (dateChange)="toggleDisable2();incresedate();isEmpty()"
                            [disabled]="ebBookingDate" autocomplete="off" placeholder="From Booking Date" readonly
                            [max]="ebmyDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset('input3');checkStatus1();"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br>

                      </div>

                      <div class="col-md-3" style="margin-top: 19px">

                        <mat-form-field>
                          <input [min]="ebFinal" #input4 matInput [disabled]="ebBookingDate"
                            [(ngModel)]="ebSearch_details.bookingdate_to" [matDatepicker]="pickerTO" [max]="newDate"
                            autocomplete="off" placeholder="To Booking Date" (dateChange)="isEmpty()" readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTO></mat-datepicker>
                        </mat-form-field>
                        <button type="button" class="close opa" (click)="reset('input4');checkStatus1();"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br>
                        <span *ngIf="ebInvalidDate" style="color: red;font-size: 10px"> 'To' date should be greater than
                          'From'
                          date </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clr"></div>

                <div class="sdiv">
                  <div class="btn clear-button button-margin">

                    <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false " (click)="searchData()"
                      type="button">
                      <em class="fa fa-search "></em>&nbsp;Search
                    </button>
                    <button class="btn btn-primary  commonbutt" type="button" (click)="getdownload()"
                      [disabled]="IsEmptyVal == false">
                      Download
                    </button>
                  </div>
                </div>
                <div class="errwrap">
                  <div class="errdiv1" id="err"></div>
                </div>
                <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                  [hidden]="ebSearchlist">
                  <table aria-describedby="existingBookingDetails" class="table table-striped" *ngIf="!loader"
                    [mfData]="serachtabledata" [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 10%">Booking Reference No</th>
                        <th scope="col" style="width: 10%">INTERMILES Number</th>
                        <th scope="col" style="width: 10%">PNR</th>
                        <th scope="col" style="width: 10%">Booking Date</th>
                        <th scope="col" style="width: 10%">Ticket No</th>
                        <th scope="col" style="width: 10%">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="link" *ngFor="
                          let item of (search_detail_list
                            | paginate: { itemsPerPage: 10, currentPage: ebp ,totalItems:totalItems})
                        " (click)="book_details(item.FB_BOOKING_REF_NO, 'book')">

                        <td *ngIf="item.STATUS_NAME!='Booked'">{{ item.Booking_Ref}}</td>
                        <td *ngIf="item.STATUS_NAME=='Booked'">{{ item.Booking_Ref}}</td>
                        <ng-container *ngIf="ebTypeOfRedem == 'A'">
                          <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                            NA
                          </td>
                          <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                            {{ item.JP_NUMBER }}
                          </td>
                        </ng-container>
                        <ng-container *ngIf="ebTypeOfRedem == 'R'">
                          <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                            NA
                          </td>
                          <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                            {{ item.JP_NUMBER.slice(2, 11) }}
                          </td>
                        </ng-container>

                        <td *ngIf="item.AIRLINE_PNR == undefind || item.AIRLINE_PNR == null || item.AIRLINE_PNR == ''">
                          NA</td>
                        <td *ngIf="item.AIRLINE_PNR != undefind && item.AIRLINE_PNR != null && item.AIRLINE_PNR != '' ">
                          {{
                          item.AIRLINE_PNR}}
                        </td>
                        <td *ngIf="item.STATUS_NAME!='Booked'">{{ item.BOOKING_DATE | date: "dd-MM-yyyy HH:mm:ss" }}
                        </td>
                        <td *ngIf="item.STATUS_NAME=='Booked'">{{ item.BOOKING_DATE | date: "dd-MM-yyyy HH:mm:ss" }}
                        </td>

                        <td *ngIf="item.Ticket_No == undefind || item.Ticket_No == null || item.Ticket_No == ''">NA</td>
                        <td *ngIf="item.Ticket_No != undefind && item.Ticket_No != null && item.Ticket_No != '' ">
                          {{ item.Ticket_No}}</td>
                        <td *ngIf="item.STATUS_NAME!='Booked'">{{ item.STATUS_NAME }}</td>
                        <td *ngIf="item.STATUS_NAME=='Booked'">{{ item.STATUS_NAME }}</td>

                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="6">

                          <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                          </pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                  <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr"> {{noresult}} </h1>
                </div>
                <div *ngIf="loader">
                  <div style="margin: 0 auto; text-align: center;">
                    <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="bookinglist" class="searchdiv">
  <div class="card screen-wrapper" *ngIf="!loader">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ ebScreenTitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div class="btn back-button button-margin ">

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>

        </div>
      </div>
    </div>
    <div class="card " style="margin-top: 10px;">
      <div class="card-body" style="margin: 0px -14px;">
        <div class="form-group col-md-12">
          <div class="col-md-4 colum-head">
            <label>Booking Ref no :
            </label>
            <span> {{ booking_ref_no }}</span>
          </div>
          <div class="col-md-4 colum-head"
            *ngIf="segment_details1[0].AIRLINE_PNR != undefind && segment_details1[0].AIRLINE_PNR != null">
            <label> PNR : </label>
            <span> {{ segment_details1[0].AIRLINE_PNR }}</span>
            <ng-container
              *ngIf="segment_details2.length != 0 && segment_details2[0].AIRLINE_PNR != undefind && segment_details2[0].AIRLINE_PNR != null && segment_details2[0].AIRLINE_PNR != 'undefind' && segment_details2[0].AIRLINE_PNR != 'null'">
              <span *ngIf="segment_details1[0].AIRLINE_PNR != segment_details2[0].AIRLINE_PNR"> , {{
                segment_details2[0].AIRLINE_PNR
                }}
              </span>
            </ng-container>
          </div>
          <div class="col-md-4 colum-head">
            <label>INTERMILES Number/Tier : </label>

            <ng-container *ngIf="ebTypeOfRedemption == 'A'">
              <ng-container *ngIf="booking_details_info.TIER != undefind && booking_details_info.TIER != null">
                <span> {{ booking_details_info.JP_NUMBER }}/{{ booking_details_info.TIER }}</span>
              </ng-container>
              <ng-container *ngIf="booking_details_info.TIER == undefind || booking_details_info.TIER == null">
                <span> {{ booking_details_info.JP_NUMBER }}</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="ebTypeOfRedemption == 'R'">
              <span> {{ (booking_details_info.JP_NUMBER).slice(2, 11) }}/{{ booking_details_info.TIER }}</span>
            </ng-container>
          </div>

          <div *ngIf="MilesYouHave != '0'" class="col-md-4 colum-head"><label *ngIf="MilesYouHave != '0'">Miles Redeemed
              : </label>
            <span *ngIf="MilesYouHave != '0'"> {{MilesYouHave}} INTERMILES</span>
          </div>
          <div class="col-md-4 colum-head"
            *ngIf="booking_details_info.length != 0 && booking_details_info.MORE_TO_BUY_JPMILES != 0">
            <label>Miles Purchased : </label>
            <span> {{booking_details_info.MORE_TO_BUY_JPMILES}} INTERMILES
            </span>
          </div>
          <div class="col-md-4 colum-head"
            *ngIf="booking_details_info.PAYMENT_MODE != undefind && booking_details_info.PAYMENT_MODE != null">
            <label>Payment Mode : </label>
            <span> {{booking_details_info.PAYMENT_MODE}}</span>
          </div>

          <div class="col-md-4 colum-head"
            *ngIf="booking_details_info.length != 0 && booking_details_info.MORE_TO_BUY_JPMILES != 0">
            <label>Cost of Additional INTERMILES : </label>
            <span> Rs.</span><span> {{Cost_Additional_JpMiles}}</span>
          </div>
          <div class="col-md-4 colum-head"
            *ngIf="booking_details_info.length != 0 && booking_details_info.MORE_TO_BUY_JPMILES != 0"><label>GST
              on Additional INTERMILES : </label>
            <span> Rs.</span><span> {{GST_ON_MILES}}</span>
          </div>
          <div class="col-md-4 colum-head"
            *ngIf="booking_details_info.length != 0 && booking_details_info.CASH_PAID != 0"><label>Total
              Amount : </label><span> Rs.</span>
            <span> {{TOTAL_AMOUNT}}</span>
          </div>

          <div class="col-md-4 colum-head">
            <label>Trip Type : </label>
            <span style="text-transform: capitalize"> {{ (booking_details_info.TRIP_TYPE).toLowerCase() }}
            </span>
          </div>
          <div class="col-md-4 colum-head">
            <label>Travel Type : </label>
            <span style="text-transform: capitalize"> {{ booking_details_info.TRAVEL_TYPE }}
            </span>
          </div>
          <div class="col-md-3"></div>
        </div>

      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h3 style="margin: 0px 15px;width: 20%">
          <em class="fa fa-plane" style=" font-size: 22px;"></em> Reservation Details

        </h3>
        <div class="card " style="margin-top: 10px;">

        </div>
        <div class="form-group col-md-12">
          <div><strong style="font-size: 14px;">Pax Details:</strong></div>
          <table aria-describedby="existingBookingPaxData" class="table1"
            style="width: auto !important;margin-left: 0 !important;">
            <tr>
              <th scope="col" style="width: auto;padding: 9px;">Pax Type</th>
              <th scope="col" style="width: auto;padding: 9px;">Title</th>
              <th scope="col" style="width: auto;padding: 9px;">First Name</th>
              <th scope="col" style="width: auto;padding: 9px;">Last Name</th>
              <th scope="col" style="width: auto;padding: 9px;">Ticket Number</th>
            </tr>
            <tr *ngFor="let pax of selectedOutboundPax; let i = index">
              <td *ngIf="pax.PASSENGER_TYPE == 'ADT'">Adult</td>
              <td *ngIf="pax.PASSENGER_TYPE == 'CHD'">Child</td>
              <td *ngIf="pax.PASSENGER_TYPE == 'INF'">Infant</td>
              <td>{{pax.TITLE}}</td>
              <td>{{ pax.FIRST_NAME }}</td>
              <td>{{ pax.LAST_NAME }}</td>
              <td *ngIf="pax.TICKET_NO == undefind || pax.TICKET_NO == null || pax.TICKET_NO == ''">NA</td>
              <td *ngIf="pax.TICKET_NO != undefind && pax.TICKET_NO != null && pax.TICKET_NO != '' ">{{ pax.TICKET_NO}}
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-12">
          <div><strong style="font-size: 14px;">Itinerary Details</strong></div>
          <table aria-describedby="existingItineraryData" class="table" style="margin-bottom: 0px !important;">
            <tr>
              <th scope="col">Flight</th>
              <th scope="col">RBD</th>
              <th scope="col">Fare Product</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
              <th scope="col">Dep Date</th>
              <th scope="col">Dep Time</th>
              <th scope="col">Arr Date</th>
              <th scope="col">Arr Time</th>
              <th scope="col">Status</th>
            </tr>
            <tr *ngFor="let segment of segment_details1">
              <td>{{ segment.AIRLINE_CODE }}-{{ segment.FLIGHT_NO }}</td>
              <td>{{ segment_details1[0].BOOKING_CLASS }}</td>
              <td><span *ngIf="segment_details1[0].FARE_PRODUCT_CATEGORY_TYPE == 'E'"> Economy</span>
                <span *ngIf="segment_details1[0].FARE_PRODUCT_CATEGORY_TYPE == 'B'"> Business</span>
                {{segment_details1[0].FARE_PRODUCT_CATEGORY}}
              </td>
              <td>{{ segment.ORIGIN }} ({{segment.ORIGIN_CITY}}) </td>
              <td>{{ segment.DESTINATION }} ({{segment.DESTINATION_CITY}}) </td>
              <td>{{ segment.DEPT_DATE | date : 'dd-MM-yyyy'}}</td>
              <td>{{ segment.DEPT_TIME }} hrs </td>
              <td>{{ segment.ARR_DATE | date : 'dd-MM-yyyy' }}</td>
              <td>{{ segment.ARR_TIME }} hrs </td>
              <td *ngIf="cancelbtn == true && booking_details[0].BOOKING_STATUS == '2'">Booked</td>
              <td *ngIf="cancelbtn == false || booking_details[0].BOOKING_STATUS == '11'">Canceled</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '4'">Failed</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '1'">Pending</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '0'">NA</td>
            </tr>

            <tr *ngFor="let segment of segment_details2;">
              <td>{{ segment.AIRLINE_CODE }}-{{ segment.FLIGHT_NO }}</td>
              <td>{{ segment_details2[0].BOOKING_CLASS }}</td>
              <td><span *ngIf="segment_details2[0].FARE_PRODUCT_CATEGORY_TYPE == 'E'"> Economy</span>
                <span *ngIf="segment_details2[0].FARE_PRODUCT_CATEGORY_TYPE == 'B'"> Business</span>
                {{segment_details2[0].FARE_PRODUCT_CATEGORY}}
              </td>
              <td>{{ segment.ORIGIN }} ({{segment.ORIGIN_CITY}}) </td>
              <td>{{ segment.DESTINATION }} ({{segment.DESTINATION_CITY}}) </td>
              <td>{{ segment.DEPT_DATE | date : 'dd-MM-yyyy'}}</td>
              <td>{{ segment.DEPT_TIME }} hrs </td>
              <td>{{ segment.ARR_DATE | date : 'dd-MM-yyyy' }}</td>
              <td>{{ segment.ARR_TIME }} hrs </td>
              <td *ngIf="cancelbtn == true && booking_details[0].BOOKING_STATUS == '2'">Booked</td>
              <td *ngIf="cancelbtn == false || booking_details[0].BOOKING_STATUS == '11'">Cancled</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '4'">Failed</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '1'">Pending</td>
              <td *ngIf="booking_details[0].BOOKING_STATUS == '0'">NA</td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-12">
          <div><strong style="font-size: 14px;">Ancillaries:</strong></div>
        </div>
        <div class="form-group col-md-12">
          <div class="col-md-4 ansi">
            <label *ngIf="booking_details_info.IS_MEAL_INCLUDED == 1 ">
              Meals Included
            </label>
            <label *ngIf="booking_details_info.IS_MEAL_INCLUDED != 1 ">
              Meals Not Included
            </label>
          </div>
        </div>
        <div class="form-group col-md-12">
          <div class="col-md-4 ansi">
            <ng-container *ngIf="ebTypeOfRedemption == 'A'">
              <ng-container
                *ngIf="booking_details_info.IS_REFUNDABLE == '1' || booking_details_info.IS_REFUNDABLE == 1 ">
                <label>
                  Refundable
                </label>
              </ng-container>

              <ng-container *ngIf="booking_details_info.IS_REFUNDABLE != '1' ">
                <label>
                  Non Refundable
                </label>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="ebTypeOfRedemption == 'R'">
              <label>
                Non Refundable
              </label>
            </ng-container>
          </div>
        </div>
        <div class="form-group col-md-12">
          <div class="col-md-4 ansi">
            <label>
              Baggage Information
            </label>
          </div>
        </div>
        <div class="form-group col-md-12">

          <table aria-describedby="existingBaggageData" class="table1"
            style="width: 44% !important; margin-left: 0 !important;">
            <tr>
              <th scope="col" style="width: 12%">Airline Details</th>
              <th scope="col" style="width: 11%">Air Route</th>
              <th scope="col" style="width: 13%">Check -in</th>
              <th scope="col" style="width: 10%">Cabin</th>
            </tr>
            <tr *ngFor="let seg of segment_details; let i = index">
              <td>{{seg.AIRLINE_CODE}}-{{seg.FLIGHT_NO}}</td>
              <td>{{seg.ORIGIN}}-{{seg.DESTINATION}}</td>
              <td>{{seg.CHILD_INCL_CHECKIN_BAG_ALLOWANCE}}
                <ng-container>


                  {{seg.INFANT_INCL_CHECKIN_BAG_ALLOWANCE }}
                </ng-container>

                / person
              </td>
              <td>7 kg / person</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loader">
    <div style="margin: 0 auto; text-align: center;">
      <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">
    </div>
  </div>
  <ng-container *ngIf="!loader">
    <div style="float:right" *ngIf="cancelbtn == true && booking_details_info.BOOKING_STATUS == '2'">
    </div>
  </ng-container>

  <div class="clr"></div>
</div>